export { default } from './GlobalStyles';